import React, { useEffect, useState } from 'react';

import { ButtonRound, Flexer } from '@ontruck/orc';

import { StyledNoWrap } from 'modules/assignment-cards/styled';

import { ServiceTagFTC } from 'components/ServiceTag';
import DriverCost from '../../assignment-cards/components/DriverCost';
import { StyledClose } from '../styled/StyledDriverHeaderInfo';
import { StyledDriverHeader } from '../styled/StyledDriverHeader';

const HeaderInfo = ({ driver, driverJourneys, fetchingJourneys, onRemoveClick, allowRemove }) => {
  const [timeAvailable, setTimeAvailable] = useState('not available');
  useEffect(() => {
    const driverAvailability = driver?.availability?.available_from;
    if (driverAvailability) {
      const availability = Date.now() - new Date(driverAvailability).getTime();
      const hours = Math.floor(availability / 3600000);
      const mins = Math.round(((availability % 86400000) % 3600000) / 60000);

      let availabilityText;
      if (isNaN(hours) || isNaN(mins)) {
        availabilityText = 'not available';
      } else if (hours > 24) {
        availabilityText = '+24h ago';
      } else {
        availabilityText = `${hours >= 1 ? hours + 'h' : mins + 'm'} ago`;
      }
      setTimeAvailable(availabilityText);
    }
  }, [driver]);

  if (!driver) {
    return null;
  }

  return (
    <>
      <Flexer.Child mLeft="XS" flex="1" data-testid="driver_name">
        <StyledDriverHeader>
          {driver?.contact_name}

          {driver?.is_ftc && (
            <>
              {' '}
              <ServiceTagFTC size="S" />
            </>
          )}
          <span className="availability">{timeAvailable}</span>
        </StyledDriverHeader>
      </Flexer.Child>
      <Flexer.Child mLeft="XS" flex="0">
        <StyledNoWrap>
          <DriverCost
            driver={driver}
            fetchingJourneys={fetchingJourneys}
            driverJourneys={driverJourneys}
          />
        </StyledNoWrap>
      </Flexer.Child>
      {allowRemove && (
        <StyledClose className="show-on-hover" data-testid="remove_card" onClick={onRemoveClick}>
          <ButtonRound skin="primary" size="XS" icon="close" />
        </StyledClose>
      )}
    </>
  );
};

export default HeaderInfo;
